module.exports = __webpack_public_path__ + "static/img/page_02.c44b94c1.png";